import * as types from "../actions/ActionTypes";

const defaultState = {
  showSearch: false,
  searchFilter: false,
  searchPage: 1,
  searchKey: "",
  searchValue: "",
  isSearching: false,
  searchResults: [],
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.SEARCH_SHOW:
      return {
        ...state,
        isSearching: true,
      };
    case types.SEARCH_HIDE:
      return {
        ...state,
        isSearching: false,
      };

    case types.SEARCH_FILTER:
      return Object.assign({}, state, {
        searchFilter: action.payload,
      });
    case types.SEARCH_PAGE:
      return Object.assign({}, state, {
        searchPage: action.payload,
      });
    case types.SEARCH_KEY:
      return Object.assign({}, state, {
        searchKey: action.payload,
      });
    case types.SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload,
        isSearching: action.payload !== ''
      };
    case types.SEARCH_PENDING:
      return {
        ...state,
        searchResults: [],
      };
    case types.SEARCH_FULFILLED:
      return {
        ...state,
        searchResults: action.payload,
        isSearching: false
      };
    case types.SEARCH_REJECTED:
      return {
        ...state,
        searchResults: [],
      };
    case types.SEARCH_MOOD_PENDING:
      return {
        ...state,
        searchResults: [],
      };
    case types.SEARCH_MOOD_FULFILLED:
      return {
        ...state,
        searchResults: action.payload,
        isSearching: false
      };
    case types.SEARCH_MOOD_REJECTED:
      return {
        ...state,
        searchResults: [],
      };

    default:
      return state;
  }
}
